import React from "react"

const Banner = () => {
  return (
    <section className="bg-dark pt-24 md:pt-32 md:pb-10">
      <div className="max-w-screen-md lg:max-w-screen-lg lg:mx-16 xl:mx-auto mx-auto">
        <div className="bg-secondary h-auto mx-2 md:mx-10 lg:mx-0 rounded-lg px-6 py-12 md:px-10 md:py-20">
          <div className="text-center">
            <h1 className="text-sm uppercase md:text-base lg:text-xl text-yellow-500 font-metropolis font-hairline tracking-wide">
              Experience
            </h1>
            <h2 className="text-white text-3xl md:text-4xl lg:text-5xl font-metropolis font-medium tracking-normal">
              All Projects
            </h2>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Banner
